import React, {useEffect, useState} from "react";
import { Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import { Grid as DataGrid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import FrequencyDropDown from "../frequency-dropdown";
import AddIcon from "@mui/icons-material/Add";
import { CurrencyCellMaxAmountFutureAdjustments } from "../currency-cell";
import DeleteIcon from "@mui/icons-material/Delete";
import {collectErrorMessages, getCurrentYear} from "../../shared/shared";
import YearCell from "../year-cell";
import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";
import {StyledTooltip} from "../../pages/plan-inputs";
import ValidationSignCell from "../validation-sign-cell";

const CommandCell = (deleteFn) => {
  return (props) => {
    const dataItem = props.dataItem;

    return (
      <td>
        <DeleteIcon
          onClick={() => {
            deleteFn(dataItem);
          }}
        />
      </td>
    );
  };
};

const SpendingGoals = (props) => {
  const [state, setState] = useState({
    sort: [
      {
        field: "firstName",
        dir: "asc",
      },
    ],
    page: { skip: 0, take: 10 },
    errorMessages: [],
  });

  useEffect(() => {
    setState({
      ...state,
      errorMessages: collectErrorMessages(props.validations.spendingGoals, "spending goal"),
    })
  }, [props.validations.spendingGoals]);

  const addGoal = () => {
    const prototype = {
      id: null,
      editIndex: 0,
      inEdit: true,
      amount: 0,
      endYear: getCurrentYear(),
      frequency: "MONTHLY",
      startYear: getCurrentYear(),
    };

    props.addGoal(prototype);
  };

  const spendingGoals = props.spendingGoals.map((item, index) => {
    const validation = props.validations.spendingGoals[index];
    let isValid = true;
    if (validation) {
      Object.keys(validation).forEach((key) => {
        if (!validation[key].valid) isValid = false;
      });
    }
    return {
      ...item,
      inEdit: true,
      isValid: isValid
    }
  });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} display={'flex'} alignItems={'center'}>
        <Typography >Additional Future Goals</Typography>
      </Grid>
      <Grid item xs={12}>
        {(!props.readOnly && state.errorMessages.length > 0) && (
            <div className="error-tooltip-wrapper">
              <StyledTooltip
                  arrow
                  className="error-tooltip"
                  placement="right"
                  title={
                    <ul className="error-tooltip-ul">{
                      state.errorMessages.map((e, idx) => {
                        return (
                            <li key={idx}>
                              <Typography
                                  className={'default-font'}
                                  textAlign={'left'}
                                  variant={'span'}> {e}
                              </Typography>
                            </li>
                        );
                      })}
                    </ul>
                  }
              >
                <IconButton>
                  <ErrorIcon />
                </IconButton>
              </StyledTooltip>
            </div>
        )}
        <Button onClick={addGoal}>
          <AddIcon />
          Add Goal
        </Button>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          data={orderBy(spendingGoals, state.sort).slice(
            state.page.skip,
            state.page.take + state.page.skip
          )}
          skip={state.page.skip}
          take={state.page.take}
          total={props.spendingGoals.length}
          pageable={true}
          onPageChange={(event) => {
            setState({
              ...state,
              page: event.page,
            });
          }}
          scrollable={"none"}
          editField={"inEdit"}
          onItemChange={(event) => {
            props.update(event.field)(event.dataItem, event.value);
          }}
        >
          <GridColumn title={" "} field={"isValid"} cell={ValidationSignCell} />
          <GridColumn
            title={"Frequency"}
            field={"frequency"}
            cell={FrequencyDropDown}
          />
          <GridColumn title={"Amount"} field={"amount"} cell={CurrencyCellMaxAmountFutureAdjustments} />
          <GridColumn title={"Start Year"} field={"startYear"} cell={YearCell} />
          <GridColumn title={"End Year"} field={"endYear"} cell={YearCell} />
          <GridColumn title={" "} cell={CommandCell(props.delete)} />
        </DataGrid>
      </Grid>

    </Grid>
  );
};

export default SpendingGoals;
